import { render } from "./blog-category-detail.vue?vue&type=template&id=38eeceb2"
import script from "./blog-category-detail.vue?vue&type=script&lang=js"
export * from "./blog-category-detail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__